import { defineMessages } from 'react-intl';

const messages = defineMessages({
  loggedOut: {
    id: 'You have been logged out',
    defaultMessage: 'You have been logged out',
  },
  oAuthLoginFailed: {
    id: 'Login Failed',
    defaultMessage: 'Login Failed',
  },
  oAuthLoginFailedContent: {
    id: 'Authentication failed.',
    defaultMessage: 'Authentication failed.',
  },
  authenticating: {
    id: 'Authenticating',
    defaultMessage: 'Authenticating',
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading',
  },
  Login: {
    id: 'Login',
    defaultMessage: 'Login',
  },
  LoginDescription: {
    id: 'Sign in to start session',
    defaultMessage: 'Sign in to start session',
  },
  LoginProviderDescription: {
    id: 'Select Login Provider',
    defaultMessage: 'Select Login Provider',
  },
  login: {
    id: 'Log in',
    defaultMessage: 'Log in',
  },
  loginName: {
    id: 'Login Name',
    defaultMessage: 'Login Name',
  },
  password: {
    id: 'Password',
    defaultMessage: 'Password',
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
  },
  error: {
    id: 'Error',
    defaultMessage: 'Error',
  },
  loginFailed: {
    id: 'Login Failed',
    defaultMessage: 'Login Failed',
  },
  loginFailedContent: {
    id: 'Both email address and password are case sensitive, check that caps lock is not enabled.',
    defaultMessage:
      'Both email address and password are case sensitive, check that caps lock is not enabled.',
  },
  register: {
    id: 'Register',
    defaultMessage: 'Register',
  },
  forgotPassword: {
    id: 'box_forgot_password_option',
    defaultMessage: 'Forgot your password?',
  },
  LoginWith: {
    id: 'Log in with',
    defaultMessage: 'Log in with',
  },
  RegisterWith: {
    id: 'Sign up with',
    defaultMessage: 'Sign up with',
  },
});

export default messages;
